import { Component, OnInit } from '@angular/core';
import { DialerService } from '../dialer.service';
import { LoginService } from 'src/app/login.service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-dialer-uploaded-excel-details',
  templateUrl: './dialer-uploaded-excel-details.component.html',
  styleUrls: ['./dialer-uploaded-excel-details.component.css'],
  providers: [DatePipe]
})
export class DialerUploadedExcelDetailsComponent implements OnInit {

  userProfile: any;
  userData: any;
  didList: any[] = [];
  sublist: any[] = [];
  UserProfileId: number;
  projectlist: any[] = [];
  customerType: string = '';
  dataTable: any;
  fromdate: any;
  todate: any;
  fileNameFilter: string = '';
  statusFilter: string = '';
  dIdNumberFilter: number;
  subUserFilter: '';
  subUser: number;
  dialerExcelUploadData: any[] = [];
  categoryFilter: string = '';
  category: number;
  projectFilter: string = '';
  project: number;
  SUBInitial: any
  categorylist: any[] = [];
  keyword = "name";
  subcategoryFilter: string = '';
  subcategory: number;
  subcategorylist: any[] = [];
  isFromDateRequired: boolean = false;
  tableData: any[] = [];
  isToDateRequired: boolean = false;
  isFromDateGreater: boolean = false;
  categoryError: boolean = false;
  subcategoryError: boolean = false;



  constructor(
    private dialerService: DialerService,
    private loginservice: LoginService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.onGetDids();
    this.onFocusedDID();
    this.onFocusedProject();
    this.currentDateData();
  }

  currentDateData() {
    const datePipe = new DatePipe('en-US')
    const currentDate = new Date();
    const tenDaysAgo = new Date();
    tenDaysAgo.setDate(currentDate.getDate() - 10);

    this.fromdate = datePipe.transform(tenDaysAgo, 'yyyy-MM-dd HH:mm:ss');
    this.todate = datePipe.transform(currentDate, 'yyyy-MM-dd HH:mm:ss');
  }

  ngAfterViewInit() {
    this.initializeExcelDataTable();
  }

  onGetDids() {
    this.userProfile = JSON.parse(localStorage.getItem("userdata"))
    this.userData = this.loginservice.getUserdata(true);
    const loggedInUserId = this.userData.id;

    this.dialerService.getDids(loggedInUserId).subscribe((response: any) => {
      if (response) {
        this.didList = response.data;
      }
    });
  }

  // SUBUSER AutoComplete
  selectDID(item: any) {
    this.subUser = item.id;
    this.onFocusedProject()
  }

  onChangeSearchDID(val: string) {
    this.UserProfileId = this.userData.id;
    this.dialerService.searchdialeruserList(val, this.UserProfileId).subscribe(
      (data: any) => {
        this.sublist = data;
      });
  }

  onFocusedDID() {
    this.UserProfileId = this.userData.id;
    this.dialerService.getdialeruserList(this.UserProfileId).subscribe(
      (data: any) => {
        this.sublist = data;
      });
  }

  onClearDID() {
    this.subUser = null;
  }

  // PROJECT AutoComplete
  selectProject(item: any) {
    this.project = item.id;
    this.customerType = item.customer_type;

    this.category = null;
    this.categoryFilter = '';
    this.categorylist = [];

    this.subcategory = null;
    this.subcategoryFilter = '';
    this.subcategorylist = [];

    this.categoryError = false;
    this.subcategoryError = false;
    this.onFocusedcategory()
  }

  onChangeSearchProject(val: string) {
    this.UserProfileId = this.userData.id;
    this.dialerService.searchDialerExcelUploadProjectList(val, this.UserProfileId).subscribe(
      (data: any) => {
        this.projectlist = data;
      });
  }

  onFocusedProject() {
    this.UserProfileId = this.userData.id;
    const projectlist_body = {
      "user_id": this.UserProfileId
    }
    this.dialerService.getProjectList(projectlist_body).subscribe(
      (response: any) => {
        if (response.status === 1) {
          this.projectlist = response.data.projects;
        }
      });
  }

  onClearProject() {
    this.project = null;
    this.customerType = '';

    this.category = null;
    this.categoryFilter = '';
    this.categorylist = [];

    this.subcategory = null;
    this.subcategoryFilter = '';
    this.subcategorylist = [];
  }

  // CATEGORY AutoComplete
  selectcategory(item: any) {
    this.category = item.id;
    this.subcategoryError = false;
    this.onFocusedsubcategory()
  }

  onChangeSearchcategory(val: string) {
    this.dialerService
      .searchdialercategoryList(val, this.project)
      .subscribe((data: any) => {
        this.categorylist = data;
      });
  }

  onFocusedcategory() {
    if (!this.project) {
      this.categoryError = true;
      return;
    }
    this.categoryError = false;

    this.dialerService.getdialercategoryList(this.project).subscribe(
      (data: any) => {
        this.categorylist = data;
      });
  }

  onClearcategory() {
    this.category = 0;
  }

  // SUBCATEGORY AutoComplete
  selectsubcategory(item: any) {
    this.subcategory = item.id;
  }

  onChangeSearchsubcategory(val: string) {
    this.dialerService
      .searchdialersubcategoryList(val, this.category)
      .subscribe((data: any) => {
        this.subcategorylist = data;
      });
  }

  onFocusedsubcategory() {
    if (!this.category) {
      this.subcategoryError = true;
      return;
    }
    this.subcategoryError = false;

    this.dialerService.getdialersubcategoryList(this.category).subscribe(
      (data: any) => {
        this.subcategorylist = data;
      });
  }

  onClearsub() {
    this.subcategory = 0;
  }

  onDownloadExcelFile(fileid: number, fileName: string) {
    this.dialerService.downloadExcelFile(fileid).subscribe((response: Blob) => {
      if (response) {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else {
        Swal.fire("Error", "Failed to download file", "error");
      }
    }, error => {
      Swal.fire("Error", "Something went wrong", "error");
    });

  }

  onApplyFilter() {

    // FromDate ToDate Validation
    if (this.todate && !this.fromdate) {
      this.isFromDateRequired = true;
      return;
    } else {
      this.isFromDateRequired = false;
    }

    if (!this.todate) {
      this.isToDateRequired = false;
    }

    if (this.fromdate && this.todate && this.fromdate > this.todate) {
      this.isFromDateGreater = true;
      return;
    } else {
      this.isFromDateGreater = false;
    }

    if (this.dataTable) {
      this.dataTable.ajax.reload();
    }
  }

  clearFilter() {
    this.fileNameFilter = '';
    this.statusFilter = '';
    this.dIdNumberFilter = null;
    this.subUserFilter = '';
    this.projectFilter = null;
    this.customerType = '';
    this.categoryFilter = '';
    this.subcategoryFilter = '';
    this.project = null;
    this.category = null;
    this.subcategory = null;
    this.subUser = null;

    if (this.dataTable) {
      this.dataTable.ajax.reload();
    }
  }

  private initializeExcelDataTable(): void {
    if (this.dataTable) {
      return;
    }

    this.dataTable = $('#excelDataTable').DataTable({
      responsive: true,
      lengthChange: false,
      autoWidth: false,
      language: {
        emptyTable: "No data available"
      },
      buttons: [],
      paging: true,
      pageLength: 10,
      serverSide: true,
      processing: true,
      searching: false,
      ordering: false,

      ajax: (dataTablesParameters: any, callback: any) => {
        const page = (dataTablesParameters.start / dataTablesParameters.length) + 1;
        const pageSize = dataTablesParameters.length;
        this.UserProfileId = this.userData.id;

        const formattedFromDate = this.fromdate ? this.datePipe.transform(this.fromdate, 'yyyy-MM-dd HH:mm:ss') : null;
        const formattedToDate = this.todate ? this.datePipe.transform(this.todate, 'yyyy-MM-dd HH:mm:ss') : null;

        const dialerUploadedExcel_Data = {
          "user_id": this.UserProfileId,
          "from_date": formattedFromDate,
          "to_date": formattedToDate,
          "file_name": this.fileNameFilter,
          "status": this.statusFilter,
          "did_id": this.dIdNumberFilter,
          "subuser_id": this.subUser,
          "project_id": this.project,
          "project_category_id": this.category,
          "project_subcategory_id": this.subcategory,
        };

        this.dialerService.getExcelDetails(dialerUploadedExcel_Data, page, pageSize).subscribe((response: any) => {
          if (response.status === 1) {
            const datePipe = new DatePipe('en-US');
            const processedData = response.data.results.map((item: any, index: number) => ({
              ...item,
              slno: (page - 1) * pageSize + index + 1,
              created_at: datePipe.transform(item.created_at, 'dd-MMM-yyyy hh:mm:ss a'),
              action: `<a class="btn-downloadExcel" data-id="${item.id}" data-name="${item.name}">
                        <span><i class="fas fa-file-download text-primary"></i></span>
                      </a>`
            }));

            callback({
              recordsTotal: response.data.count,
              recordsFiltered: response.data.count,
              data: processedData
            });

          } else if (response.status === 0 || response.status === 2) {
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });

            alert(response.message);
          }
        }, error => {
          console.error("API Error:", error);
          callback({
            recordsTotal: 0,
            recordsFiltered: 0,
            data: []
          });

          alert("An error occurred while loading data. Please try again.");
        });
      },

      columns: [
        { data: 'slno', title: 'Sl.No.', className: 'text-center' },
        { data: 'name', title: 'FILE NAME', className: 'text-center' },
        {
          data: 'status',
          title: 'STATUS',
          className: 'text-center',
          render: function (data: any) {
            let colorClass = '';
            switch (data.toLowerCase()) {
              case 'success':
                colorClass = 'text-success';
                break;
              case 'processing':
                colorClass = 'text-primary';
                break;
              case 'failed':
                colorClass = 'text-danger';
                break;
              case 'pending':
                colorClass = 'text-warning';
                break;
              default:
                colorClass = 'text-secondary';
            }
            return `<span class="${colorClass} font-weight-bold">${data}</span>`;
          }
        },
        { data: 'created_at', title: 'DATE & TIME', className: 'text-center' },
        { data: 'count_success', title: 'SUCCESS COUNT', className: 'text-center' },
        { data: 'count_failed', title: 'FAILED COUNT', className: 'text-center' },
        { data: 'count_total', title: 'TOTAL COUNT', className: 'text-center' },
        { data: 'action', title: 'ACTION', className: 'text-center' }
      ],

      headerCallback: (thead: any) => {
        $(thead).find('th').css({
          'background-color': '#6c757d',
          'color': '#ffffff',
          'font-weight': 'bold',
          'text-align': 'center'
        });
      }
    });

    this.attachTableEvents();
  }

  attachTableEvents() {
    $("#excelDataTable tbody").off("click", ".btn-downloadExcel").on("click", ".btn-downloadExcel", (event: any) => {
      const id = $(event.currentTarget).data("id");
      const fileName = $(event.currentTarget).attr("data-name");
      if (id) {
        this.onDownloadExcelFile(id, fileName);
      }
    });
  }



}
